export default function () {
    function calender() {
        const date_now = dayjs();	// 現在の日付
        const date_1ml = date_now.add(1, 'M');	// 1ヶ月先の日付
        const day_num = date_now.daysInMonth();	// 今月の日数
        const week_s = parseInt(date_now.format('d'));
        const month_now = date_1ml.$M;
        const month_1ml = date_now.add(2, 'M').$M;
        $(".p-calendar__month-num").text(month_now);
    
        var calendar_arr = [];
    
        var day_diff = 0;
        
    
        calendar_loop:
        for(i=0; i<6; i++){
            if(!calendar_arr[i]) calendar_arr[i] = [];
            for(j=0; j<7; j++){
                if(i==0){
                    if(j<week_s){
                        calendar_arr[i][j] = '';
                    }else{
                        calendar_arr[i][j] = date_now.add(day_diff, 'day').format('D');
                        day_diff++;
                    }
                }else{
                    calendar_arr[i][j] = date_now.add(day_diff, 'day').format('D');
                    day_diff++;
                }
                if(day_num<day_diff){
                    for(k=parseInt(date_now.add(day_diff, 'day').format('d')); k<7; k++){
                        calendar_arr[i][k] = '';
                    }
                    break calendar_loop;
                }
            }
        }
    
        let calenderTable = '';
    
        let firstNum = false;
        calendar_arr.forEach((value, index) => {
            console.log(value, index);
            let calenderTableTr = '';
            calendar_arr[index].forEach((value, index) => {
                if(value) {
                    if(!firstNum) {
                        calenderTableTr = `${calenderTableTr}<td><a class="current" href="#">${value}</a></td>`;
                        firstNum = true;
                    } else {
                        if(index !== 0 && value　== '1') {
                            calenderTableTr = `${calenderTableTr}<td><a href="#"><span class="month">${month_1ml}</span>/${value}</a></td>`;
                        } else {
                            calenderTableTr = `${calenderTableTr}<td><a href="#">${value}</a></td>`;
                        }
                        
                    }
                } else {
                    calenderTableTr = `${calenderTableTr}<td></td>`;
                }
            });
            calenderTable = `${calenderTable}<tr><th><a href=""><i><img src="images/search_icon_arrow.png" alt=""></i></a></th>${calenderTableTr}</tr>`;
    
        });
    
        $('.p-calendar__content tbody').html(calenderTable);
    
        var dt = new Date(2021, 4 -1 , 30, 0, 0, 0);
        dt.setMonth(dt.getMonth() + 1);
        console.log(dt);
    
    }
    
    
    calender();
    
}